import PropTypes from 'prop-types';

import React, { useState } from 'react';
import { Grid, View } from '@adobe/react-spectrum';
import WorkfrontTask from './WorkfrontTask';
import Projects from './Projects';
import RecentReviewComments from '../../components/comments/RecentReviewComments';

const Home = props => {
  const { user, userEmail } = props;
  const [parentId, setParentId] = useState('');

  const getParentId = id => {
    setParentId(id);
  };

  return (
    <div className="homepage">
      <Grid
        areas={['boards comments']}
        columns={['calc(100% - size-5000)', '1fr']}
        rows={['size-1000', 'auto']}
        gap="size-300"
      >
        <View gridArea="boards" marginY="size-300" backgroundColor="gray-50">
          <Projects user={user} getParentId={getParentId} />
          <WorkfrontTask user={user} />
        </View>
        <View gridArea="comments">
          <RecentReviewComments projectID={parentId} userEmail={userEmail} />
        </View>
      </Grid>
    </div>
  );
};

Home.propTypes = {
  user: PropTypes.string,
  userEmail: PropTypes.string,
};

Home.defaultProps = {
  user: '',
  userEmail: '',
};

export default Home;
